export default __webpack_public_path__ + "static/fakegoogle_1-7797dc67727711ebdcdfe908bb48a505.jpg";